/* RAUTER — global behaviour: reveal, header, menu, tilt, parallax */
(function () {
  'use strict';

  var reduzMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revelação suave ao rolar */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduzMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Header com sombra ao rolar */
  var header = document.querySelector('.header');
  if (header) {
    var ultimo = false;
    var aoRolar = function () {
      var agora = window.scrollY > 8;
      if (agora !== ultimo) {
        header.classList.toggle('is-scrolled', agora);
        ultimo = agora;
      }
    };
    window.addEventListener('scroll', aoRolar, { passive: true });
    aoRolar();
  }

  /* Menu móvel (os rótulos vêm traduzidos do tema, em data-label-abrir / data-label-fechar) */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu-mobile]');
  var fechar = document.querySelector('[data-menu-fechar]');
  function setMenu(aberto) {
    if (!menu) return;
    menu.classList.toggle('is-open', aberto);
    document.body.classList.toggle('sem-scroll', aberto);
    if (toggle) {
      toggle.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      toggle.setAttribute('aria-label', aberto ? (toggle.getAttribute('data-label-fechar') || 'Close menu') : (toggle.getAttribute('data-label-abrir') || 'Open menu'));
    }
    if (aberto) {
      var primeiro = menu.querySelector('a, button');
      if (primeiro) primeiro.focus();
    } else if (toggle) {
      toggle.focus();
    }
  }
  if (toggle && menu) {
    toggle.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    if (fechar) fechar.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false);
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  /* Tilt 3D discreto nos cards (desktop, ponteiro fino) */
  if (!reduzMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var media = card.querySelector('.card__media');
      if (!media) return;
      var raf = null;
      card.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          media.style.transform = 'perspective(900px) rotateX(' + (y * -4) + 'deg) rotateY(' + (x * 5) + 'deg)';
        });
      });
      card.addEventListener('pointerleave', function () {
        media.style.transform = '';
      });
    });
  }

  /* Parallax sutil no hero — limitado à folga da moldura para não abrir falha */
  var heroMedia = document.querySelector('[data-parallax]');
  if (heroMedia && !reduzMotion) {
    var ticking = false;
    var parallax = function () {
      ticking = false;
      var hero = heroMedia.parentElement;
      if (!hero) return;
      var altura = hero.offsetHeight;
      var y = window.scrollY;
      if (y > altura * 1.4) return;
      var limite = altura * 0.1;
      var deslocamento = Math.min(y * 0.18, limite);
      heroMedia.style.transform = 'translate3d(0, ' + deslocamento + 'px, 0)';
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(parallax);
      }
    }, { passive: true });
    parallax();
  }
})();